var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.017 13.941c0 .56-.456 1.015-1.019 1.015-.562 0-1.019-.454-1.019-1.015 0-.56.457-1.014 1.02-1.014.562 0 1.018.454 1.018 1.014zm-.51-2.029H9.49l-.51-5.073h2.038l-.51 5.073zM9.999 1.826l8.459 15.16H1.54l8.458-15.16zm0-1.826a.305.305 0 00-.243.18L.052 17.555c-.133.243 0 .446.265.446H19.68c.285 0 .397-.203.265-.446L10.243.183A.306.306 0 009.999 0z",
    fill: "#D4231A"
  })));
}
export default SvgWarning;